import { AdminTransfer } from '../models'

export const getTransferUser = (transfer: AdminTransfer) => {
  return `${transfer.userData.user_first_name} ${transfer.userData.user_last_name}`
}

export const getTransferCompanyName = (transfer: AdminTransfer) => {
  return transfer.userData.company_name || '-'
}

export const getTransferOrderedyByDate = (a: AdminTransfer, b: AdminTransfer) => {
  const dateA = new Date(a.order.created)
  const dateB = new Date(b.order.created)
  return dateA.getTime() - dateB.getTime()
}

export const getTransfersFiltered = (text: string, bigList: AdminTransfer[]): AdminTransfer[] => {
  let newList = bigList
  if (text) {
    const searchText = text?.toLowerCase()
    newList = newList.filter(transfer => {
      return (
        transfer.order.reference?.toLowerCase()?.includes(searchText) ||
        getTransferCompanyName(transfer)?.toLowerCase()?.includes(searchText) ||
        getTransferUser(transfer).toLowerCase().includes(searchText)
      )
    })
  }
  return newList
}
